/** Valor seguro para um seletor de atributo ([data-folha="..."]); a chave do lote pode ter aspas. */
export function escaparSeletor(valor) {
  if (typeof window !== "undefined" && window.CSS?.escape) return window.CSS.escape(valor);
  return String(valor).replace(/["\\]/g, "\\$&");
}
